import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Story } from "@/components/Story";
import { MeetTheBees } from "@/components/MeetTheBees";
import { Shop } from "@/components/Shop";
import { HoneyWaitlist } from "@/components/HoneyWaitlist";
import { ContactFooter } from "@/components/ContactFooter";
import { CartDrawer } from "@/components/CartDrawer";
import { api } from "@/lib/api";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getProducts()
      .then(setProducts)
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <MeetTheBees />
        <Shop products={products} loading={loading} />
        <HoneyWaitlist />
        <ContactFooter />
      </main>
      <CartDrawer />
    </div>
  );
}
